function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Redirect, Link } from 'react-router-dom';
import { Container, Row, Col, Card, CardBody, Label, FormGroup, Button, Alert } from 'reactstrap';
import { AvForm, AvField, AvGroup, AvInput, AvFeedback } from 'availity-reactstrap-validation';
import LoaderWidget from '../../components/theme/Loader';
import logo from '../../assets/images/logo.png';
import { isUserAuthenticated } from "../../helpers/authUtils";
import { loginUser } from "../../redux/auth/authActions";
import _ from 'lodash';

class Login extends Component {
  constructor(props) {
    super(props);

    _defineProperty(this, "_isMounted", false);

    _defineProperty(this, "handleValidSubmit", (event, values) => {
      this.props.loginUser(values.username, values.password, this.props.history);
    });

    _defineProperty(this, "renderRedirectToRoot", () => {
      const isAuthTokenValid = isUserAuthenticated();

      if (isAuthTokenValid) {
        return /*#__PURE__*/React.createElement(Redirect, {
          to: "/"
        });
      }
    });

    this.handleValidSubmit = this.handleValidSubmit.bind(this);
    this.state = {
      username: null,
      password: null
    };
  }

  componentDidMount() {
    this._isMounted = true;
  }

  componentWillUnmount() {
    this._isMounted = false;
  }
  /**
   * Handles the submit
   */


  render() {
    const isAuthTokenValid = isUserAuthenticated();
    return /*#__PURE__*/React.createElement(React.Fragment, null, this.renderRedirectToRoot(), (this._isMounted || !isAuthTokenValid) && /*#__PURE__*/React.createElement("div", {
      className: "account-pages mt-5 mb-5"
    }, /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(Row, {
      className: "justify-content-center"
    }, /*#__PURE__*/React.createElement(Col, {
      lg: 5
    }, /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement("div", {
      className: "card-header pt-4 pb-4 text-center bg-primary"
    }, /*#__PURE__*/React.createElement(Link, {
      to: "/"
    }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("img", {
      src: logo,
      alt: "",
      height: "36"
    })))), /*#__PURE__*/React.createElement(CardBody, {
      className: "p-4 position-relative"
    }, this.props.loading && /*#__PURE__*/React.createElement(LoaderWidget, null), /*#__PURE__*/React.createElement("div", {
      className: "text-center w-75 m-auto"
    }, /*#__PURE__*/React.createElement("h4", {
      className: "text-dark-50 text-center mt-0 font-weight-bold"
    }, `${_.capitalize(window._env_.AUTH_MODEL_NAME)} Sign In`), /*#__PURE__*/React.createElement("p", {
      className: "text-muted mb-4"
    }, "Enter your username and password to access admin panel.")), this.props.error && /*#__PURE__*/React.createElement(Alert, {
      color: "danger",
      isOpen: this.props.error ? true : false
    }, /*#__PURE__*/React.createElement("div", null, this.props.error)), /*#__PURE__*/React.createElement(AvForm, {
      onValidSubmit: this.handleValidSubmit
    }, /*#__PURE__*/React.createElement(AvField, {
      name: "username",
      label: "Username",
      placeholder: "Enter your username",
      value: this.state.username,
      required: true
    }), /*#__PURE__*/React.createElement(AvGroup, null, /*#__PURE__*/React.createElement(Label, {
      for: "password"
    }, "Password"), /*#__PURE__*/React.createElement(AvInput, {
      type: "password",
      name: "password",
      id: "password",
      placeholder: "Enter your password",
      value: this.state.password,
      required: true
    }), /*#__PURE__*/React.createElement(AvFeedback, null, "This field is invalid")), /*#__PURE__*/React.createElement(FormGroup, null, /*#__PURE__*/React.createElement(Button, {
      color: "success"
    }, "Submit"))))))))));
  }

}

const mapStateToProps = state => {
  const {
    user,
    loading,
    error
  } = state.auth;
  return {
    user,
    loading,
    error
  };
};

export default connect(mapStateToProps, {
  loginUser
})(Login);